module.exports = __webpack_public_path__ + "img/jtyx.325f8be6.webp";